import { gql } from '@apollo/client';

export const ACCOUNT_REGISTER = gql`
    mutation AccountRegister($email: String!, $password: String!, $redirectUrl: String){
        accountRegister(input: {email: $email, password: $password, redirectUrl: $redirectUrl}) {
            requiresConfirmation
            user {
                id
            }
            accountErrors {
                field
                message
                code
            }
        }
    }`;
